import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'components/icons';

export const Logo = () => (
  <Link to="/">
    <Icons.Logo />
  </Link>
);
